module.exports = {
	"title": "Contact",
	"pageTitle": "Contact",
	"link": "contacts",
	"sections": [
		{
			"contactTitle": "Publicist",
			"contactName": "Erin Lovett",
			"contactEmail": "ELovett@wwnorton.com"
		}
	],
	"_doc": "2535be7fff32909757bf",
	"attachments": {},
	"_system": {
		"deleted": false,
		"changeset": "307:23c9ccfba204bc924bcb",
		"created_on": {
			"timestamp": "15-May-2017 17:40:31",
			"year": 2017,
			"month": 4,
			"day_of_month": 15,
			"hour": 17,
			"minute": 40,
			"second": 31,
			"millisecond": 43,
			"ms": 1494870031043,
			"iso_8601": "2017-05-15T17:40:31Z"
		},
		"created_by": "mmcginnis",
		"created_by_principal_id": "7683d13972fe921163df",
		"created_by_principal_domain_id": "3d96ab762d6c9248425b",
		"modified_on": {
			"timestamp": "30-May-2017 21:14:50",
			"year": 2017,
			"month": 4,
			"day_of_month": 30,
			"hour": 21,
			"minute": 14,
			"second": 50,
			"millisecond": 758,
			"ms": 1496178890758,
			"iso_8601": "2017-05-30T21:14:50Z"
		},
		"modified_by": "cbills",
		"modified_by_principal_id": "8396d34d48a72b11fb19",
		"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
		"previousChangeset": "305:8d650daa9d95132c7f2f"
	},
	"_statistics": {
		"a:child": 1,
		"a:child_INCOMING": 1,
		"a:has_role": 4,
		"a:has_role_INCOMING": 4,
		"a:linked": 1,
		"a:linked_INCOMING": 1
	},
	"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/2535be7fff32909757bf",
	"status": "OK"
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/contact.json
// module id = 507
// module chunks = 0